export default "https://cdn.questicon.mathletics.com/assets/images/pin-icon-fb9fdd08dab29f354849600916a02eaa.svg";